import { get } from '../../../utils';

// If we don't fill in any values we will use thes by default.
const defaultMeta = {
  description: 'Missing action description.'
}

// Right now the only meta data that is used / makes sense is a description.
// Later this might be exted to include stuff like 'fireOnce'.
const mksMeta = {
  INIT_ESTIMATOR_APP: {

    description: 'This is the first moment when all dependencies have been loaded into the applidation (virtual pageload).'
  },
  USER_ADD_BODY_STYLE_FILTER: {
    description: 'User added a body style filter on the model line select view.'
  },
  USER_REMOVE_BODY_STYLE_FILTER: {
    description: 'User removed a body style filter on the model line select view'
  },
  USER_SELECTED_MODELLINE: {
    description: 'User selected a modelline. This will cause a push state change. Context available via action params.'
  },
  USER_SELECTED_TRIM: {
    description: 'User selected a model trim. This will cause a push state change. Context available via action params.'
  },
  USER_OPENED_EDIT_TRIM_MODEL_CHOOSER: {
    description: 'User opened the trim model chooser collapsible panel.'
  },
  USER_CLOSED_EDIT_TRIM_MODEL_CHOOSER: {
    description: 'User closed the trim model chooser collapsible panel.'
  },
  USER_OPENED_ZIP_CODE_MODAL: {
    description: 'User clicked on the location text to edit or view their current zipcode/location'
  },
  USER_UPDATED_ZIP_CODE: {
    description: 'User updated their zipCode via the location modal.'
  },
  USER_UPDATED_CREDIT_RATING: {
    description: 'User updated their credit rating via dropdown box.'
  },
  USER_UPDATED_TRADE_IN_VALUE: {
    description: 'User updated their net trade in value'
  },
  USER_UPDATED_DOWN_PAYMENT: {
    description: 'User updated their down payment value'
  },
  USER_UPDATED_RETAILER_ACCESSORIES: {
    description: 'User updated their retailer accessory values'
  },
  DEALER_QUERY_SUCCESS: {
    description: 'Successfully queried the database and provided dealers to the user'
  },
  LEAD_SUBMISSION_SUCCESS: {
    description: 'successfully submitted lead to Dealer Center'
  }
};

export const getActionMeta = action => Object.assign({}, defaultMeta, get(mksMeta, [action.type]));



/** WEBPACK FOOTER **
 ** ./src/redux/middleware/analytics/meta.js
 **/